import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { MoneyPurchaseAnnualAllowanceComponent } from "../../../Common/PaymentsIn/SIPP/MoneyPurchaseAnnualAllowanceComponent";
import { SourceOfWealth } from "../../../Common/PaymentsIn/SIPP/SourceOfWealth";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { PaymentType, processTypeEnum } from "../../../Common/Resource/Contents";
import { SinglePayment } from "../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { IsaAllowance } from "../../../Common/ISA/PaymentsIn/IsaAllowance";
import { IsaHelper } from "../../../Common/Helpers/IsaHelper";
import { PensionProtection } from "../../../Common/PaymentsIn/SIPP/PensionProtection";
import { TransferIn } from "../../../Common/PaymentsIn/TransferIn/TransferIn";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { BankAccountAction } from "../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { inUseBankAccountForContribution } from "../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { FsaPermission } from "../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";

interface IPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
    data: any;
    hasCashIsa?: boolean;
}

interface IPaymentsInState {
    transferInDisabled?: boolean;
    disableJourney: boolean;
}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {
            disableJourney: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ transferInDisabled: RestrictionStore.transferDisabled() });
        CompanyWizardAction.getCompanyFsaPermissionDetail(
            ClientAccountStore.getClientAccountInfo()?.Company,
            (result: FsaPermission[]) => {
                if (
                    !result.some(
                        (ele) =>
                            ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
                            ele?.IsInclude &&
                            ele?.IsPermit
                    )
                ) {
                    this.setState({ disableJourney: true });
                }
            }
        );
    }

    isValid() {
        const flag = super.isValid();
        return flag && !this.state.disableJourney;
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            hasPaymentMethod: true,
            isReview: isReview,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    data.ClientDetails?.ActorId,
                    processTypeEnum.SinglePaymentTransfer,
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
            inUseBankAccountInstruction: inUseBankAccountForContribution(data?.Contribution),
        };
    };

    private renderFsaError() {
        if (this.state.disableJourney) {
            return <Alert message={"FCA Permissions prevents the following action."} alertType={AlertType.Error} />;
        }
        return <></>;
    }

    private renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions) {
        const { Contribution } = this.props.data;
        const { type } = this.props;
        const { onChange, data } = this.props;

        if (SubAccountTypeHelper.isWrapCash(type)) {
            return (
                <>
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                        excludeWrapCash={true}
                    />
                    <hr />
                </>
            );
        } else if (SubAccountTypeHelper.isPP(type)) {
            return (
                <>
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                    />
                    <Permission userClaim={UserClaim.AdviserPortalSPTAndRegularPaymentTransferInReadWrite}>
                        <TransferIn
                            isPost={false}
                            disabled={this.state.transferInDisabled}
                            data={Contribution?.GiaTransfers}
                            subAccountType={SubAccountType.InvestmentAccount}
                            clientDetails={ClientDetails}
                            jouneryType={processTypeEnum.SinglePaymentTransfer}
                            onChange={(changes) =>
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                    changes,
                                    data.Contribution
                                )
                            }
                            isReview={this.props.isReview}
                            showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                            onRef={(ref) => this.appendChild(ref)}
                            accountServiceProposition={this.props.data.AccountServiceProposition}
                        />
                    </Permission>
                </>
            );
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return (
                <>
                    <hr />
                    {Contribution.IsaAllowance && <IsaAllowance {...this.getProps("Contribution")} />}
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        hasPaymentMethod={true}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                    />
                    <hr />
                    {Contribution.IsaTransfers &&
                        type !== SubAccountType.CashIsa &&
                        checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentTransferInReadWrite) && (
                            <TransferIn
                                subAccountType={SubAccountType.StocksIsa}
                                data={Contribution.IsaTransfers}
                                disabled={this.state.transferInDisabled}
                                jouneryType={processTypeEnum.SinglePaymentTransfer}
                                onChange={(changes) =>
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        changes,
                                        data.Contribution
                                    )
                                }
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                isPost={false}
                                isReview={this.props.isReview}
                                onRef={(ref) => this.appendChild(ref)}
                                hasCashIsa={this.props.hasCashIsa}
                                accountServiceProposition={this.props.data.AccountServiceProposition}
                            />
                        )}
                </>
            );
        } else if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return (
                <>
                    <hr />
                    <MoneyPurchaseAnnualAllowanceComponent {...this.getProps("Contribution")} />
                    <PensionProtection label={"Edit pension protection"} {...this.getProps("Contribution")} />
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty, PaymentType.Employer]}
                        hasPaymentMethod={true}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                    />
                    <hr />
                    {Contribution.PensionTransfers &&
                        UserClaim.AdviserPortalSPTAndRegularPaymentTransferInReadWrite && (
                            <TransferIn
                                subAccountType={type}
                                disabled={this.state.transferInDisabled}
                                data={Contribution.PensionTransfers}
                                jouneryType={processTypeEnum.SinglePaymentTransfer}
                                onChange={(changes) =>
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        changes,
                                        data.Contribution
                                    )
                                }
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                isPost={false}
                                isReview={this.props.isReview}
                                onRef={(ref) => this.appendChild(ref)}
                                accountServiceProposition={this.props.data.AccountServiceProposition}
                            />
                        )}
                    {Contribution.ClientSinglePayment && Contribution.ClientSinglePayment !== null && (
                        <SourceOfWealth {...this.getProps("Contribution")} />
                    )}
                </>
            );
        }
    }

    public render(): JSX.Element {
        const { ClientDetails, AllBankAccounts, Contribution, BankAccountInstructions } = this.props.data;
        const { type } = this.props;

        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} />
                    {Contribution?.AdviceGiven &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else if (SubAccountTypeHelper.isWrapCash(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} />
                    {Contribution?.AdviceGiven &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else if (SubAccountTypeHelper.isPP(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} />
                    {Contribution?.AdviceGiven &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} />
                    {(Contribution?.AdviceGiven || IsaHelper.hasPaymentsTransfer(Contribution)) &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else {
            return (
                <div>
                    <h2>Payments in</h2>
                </div>
            );
        }
    }
}
